/**
 * BookingData.js contains all of the data and methods directly related to BookingComponents
 * and their individaul props
 * @see all Booking mixins
 * @see CreateLesson.vue manipulates form object and assignment
 */
export default {
    data() {
        return {};
    },
    methods: {
        /*$_data_getRescheduleIds(target) {
            if (!this.form.type.reschedule) {
                this.$_controls_blurInput();
                return;
            }
            let reschedules = this.apiCancelledLessons.length
                ? this.apiCancelledLessons.map((e) => {
                      return {
                          id: e.id,
                          reschedule_minutes: e.reschedule_minutes,
                          altered: false,
                      };
                  })
                : [];
            if (this.originalEvent) {
                reschedules.unshift(
                    JSON.parse(JSON.stringify(this.originalEvent))
                );
            }
            if (
                !reschedules.length &&
                !this.originalEvent &&
                !this.showAllRescheduleStudents
            ) {
                this.showNoRescheduleAlert();
            }
            if (this.showAllRescheduleStudents) {
                this.$_controls_blurInput();
            }

            let iterator = target;
            loop1: for (let y = 0; y < reschedules.length; y++) {
                loop2: for (let i = 0; i < target / 15; i++) {
                    if (reschedules[y].reschedule_minutes > 0) {
                        reschedules[y].reschedule_minutes -= 15;
                        reschedules[y].altered = true;
                        iterator -= 15;
                        if (iterator == 0) {
                            break loop2;
                        }
                    }
                }
                if (iterator == 0) {
                    this.rescheduleCredit = reschedules.filter(
                        (e) => e.altered == true
                    );

                    this.$_controls_blurInput();
                    return;
                }
            }
        },*/
        $_data_checkRescheduleValues(lessonType, duration, student) {
            if (!lessonType?.reschedule) return;
            let totalMinutes = this.apiCancelledLessons["totalMinutes"];
            let totalPasses = this.apiCancelledLessons["totalPasses"];
            let canExchangePasses = this.apiCancelledLessons.lessons?.filter(
                (e) => e.group_event?.can_exchange_passes
            );

            if (canExchangePasses) {
                // multiply by 30: that's the exchange rate for group class -> private lesson
                let addMinutesFromPasses = canExchangePasses.length * 30;
                totalMinutes += addMinutesFromPasses;
            }

            let bookingType = lessonType.originalType;

            if (!duration && !totalMinutes && !totalPasses) {
                return this.showNoRescheduleAlert();
            }

            let consumesPasses = ["Assessment", "Drop-In", "Event"].includes(
                bookingType
            );

            let consumesMinutes = !!(
                ["Weekly Lesson"].includes(bookingType) && duration
            );

            let canCoverMinutes = duration ? totalMinutes >= duration : false;

            if (false) {
                console.log("checkRescheduleValues: ", {
                    consumesMinutes: consumesMinutes,
                    consumesPasses: consumesPasses,
                    totalMinutes: totalMinutes,
                    totalPasses: totalPasses,
                    duration: duration,
                    canCoverMinutes: canCoverMinutes,
                });
            }

            if (
                (consumesMinutes && !canCoverMinutes) ||
                (consumesPasses && !totalPasses)
            ) {
                this.showNoRescheduleAlert(student);
            }
        },
        $_data_getAssignmentFromInterval() {
            if (this.bookingSource.isCalendar) return;
            if (this.event?.assignment) return this.event.assignment;

            let assignment = this.searchAssignments.find(
                (e) =>
                    moment(new Date(e.starts_at)).isSameOrBefore(
                        this.$_data_lessonStart
                    ) &&
                    moment(new Date(e.ends_at)).isSameOrAfter(
                        this.$_data_lessonEnd
                    )
            );
            return assignment;
        },
        /*$_data_getAutoStudent(event) {
            if (this.$page.props.staffView) {
                return event.student;
            }
            if (this.$page.props.relationships.length < 2) {
                this.form.student = this.$page.props.auth.user;
                this.$_apis_getCancelledLessons();
            }
        },*/
        /**
         *
         * @param {*} event
         * @returns {object || null}
         */
        $_data_getAutoTeacher(event) {
            //get teacher from event or assignment data, authorized user, or otherwise null;
            let teacher =
                (event?.teacher || event?.assignment?.teacher) ?? null;
            if (this.$_data_authIsOnlyTeacher)
                teacher = this.$page.props.auth.user;
            return teacher;
        },
        /**
         * Use to set duration from calendar booking
         * A user might click and drag on the calendar and then pick a type that doesn't support that duration
         * @param {object} event
         * @returns {object || null}
         */
        $_data_getAutoDuration(event, assessmentType) {
            if (event.type?.event) return null;
            if (event.type?.assessment) {
                return assessmentType?.duration ?? null;
            }
            let durationValue = null;
            let duration = event.duration;

            // Assessments are restricted to 30 minutes unless an assessmentType is set
            // Holds can be any length, otherwise limit to 90 minutes. Remove between 60 and 90 options

            /*
            if(duration < event.type.minDuration) duration = event.type.minDuration;
            if(duration > event.type.maxDuration) duration = event.type.maxDuration;
            */
            if (event.type?.assessment) {
                durationValue = 30;
            } else if (event.type?.hold) {
                durationValue = duration;
            } else if (duration > 90) {
                durationValue = 90;
            } else if (duration < 90 && duration > 60) {
                durationValue = 60;
            } else {
                durationValue = duration;
            }

            return durationValue;
        },

        $_data_getAutoBillingUser(student, option) {
            if (!student) return null;
            if (option?.courtesy) return option.billingUser;
            if (option?.user) return option.user;

            let getRelationships = this.relationships
                ? this.relationships.filter((e) => e.email)
                : [];

            if (!this.$page.props.staffView) {
                if (!this.relationships) {
                    console.log("no relationships set in view");
                }
                getRelationships = this.relationships;
            } else {
                getRelationships = student.relationships.filter((e) => e.email);
            }
            if (!getRelationships.length) {
                if (!student.email) {
                    this.showAxiosAlert(
                        "This user is unable to make purchases"
                    );
                }
                return student;
            }
            if (getRelationships.length == 1) {
                // I think I was doing this to auto select the student if they have an email, but then I'm just having to set the billing user elsewhere
                // TODO: investigate where that is
                //if (student.email) return null;
                return getRelationships[0];
            }

            return null;
        },
        /**
         * @param {*} event
         * @returns {object || null}
         */
        $_data_getAutoRoom(event) {
            let room = null;
            if (!event) room = this.assignment?.room;
            if (event?.assignment) room = event.assignment.room;
            if (event?.resource) {
                room = {
                    id: event.resource.id,
                    title: event.resource.title,
                };
            }
            return room;
        },
        $_data_setAutoRepeating(event) {
            this.form.repeating = this.form.type?.recurring;
        },
        /**
         * @returns {boolean || null}
         */
        $_data_getAutoOnline(event) {
            if (!event) return null;
            if (event.assignment?.availability?.online_only) return true;
            if (this.$page.props.auth?.user?.virtual_client) return true;
            if (event.type?.hold) return false;
            return null;
        },
        /**
         * @returns {object || null}
         */
        $_data_getAutoInstrument(event) {
            if (event.type?.hold || event.type?.event) {
                return null;
            }

            // handle if booking from calendar in instrument view
            if (event.instrumentView) return event.instrument;

            let assessmentType = this.$_data_getAutoAssessmentType(event);
            if (assessmentType?.apl) return event.instrument;

            const instrumentSource =
                event.assignment?.availability?.instruments ??
                event.teacher?.instruments;

            return instrumentSource?.length == 1 ? instrumentSource[0] : null;
            /*let teacher = this.form.teacher;
            if (!teacher) return null;
            if (teacher.instruments.length == 1) {
                return teacher.instruments[0];
            }*/
        },
        /**
         * @param {*} event
         * @returns {object || null}
         */
        $_data_getAutoAssessmentType(event) {
            if (!event?.type?.originalType.includes("Assessment")) return null;
            return {
                lesson: true,
                display: "Lesson",
                name: "Assessment",
                duration: 30,
            };
            /*if (this.$_data_teachesPiano == false || event.duration == 30) {
                return {
                    lesson: true,
                    display: "Lesson",
                    name: "Assessment",
                    duration: 30,
                };
            }
            // sets assessment type for direct reschedules
            // or 15 minute select on calendar
            /*if (event.duration == 15) {
                return {
                    apl: true,
                    display: "Piano Lab",
                    name: "Piano Lab Assessment",
                    duration: 15,
                };
            }
            return null;*/
        },
        // return first found missed lesson and use to get option and type
        // or pass in option and get missed lesson that matches .access
        $_data_getAutoCredit() {
            let type = this.form.type;
            let cancelledLessons = this.apiCancelledLessons?.lessons ?? [];
            /*autoCredit = this.apiCancelledLessons?.lessons?.find((e) => {
                return e.type.name == type.name || e.type.name == "Reschedule";
            });*/
            // this is okay to do because it's only for staff. clients will always be presented a list
            let autoCredit =
                cancelledLessons.length == 1 ? cancelledLessons[0] : null;

            return autoCredit ?? this.form.credit;
        },
        $_data_reset(clearForm, exclude = []) {
            if (clearForm) {
                this.form.reset();
                this.assignment = null;
                this.availability = null;
                this.conflicts = [];
                this.stepHistory = {};
                this.stepSequence = [];
            } else {
                this.$emit("reset");
            }
        },
        /**
         * Selects single purchase option if there is a definitively correct option
         * @see this._data_filterPurchaseOptions()
         * I think there's a better way to organize these three methods,
         * split apart so I can shortcircuit this._data_filterPurchaseOptions()
         * @param {object} lesson
         * @param {object} student
         * @param {object} assessmentType
         * @returns {?object}
         */
        $_data_getAutoPurchaseOption(lesson, student, assessmentType, credits) {
            if (!lesson) return null;

            // Added this line to handle junior reschedules. could be better.
            // Otherwise it will return the no purchase option available error
            // This is because autoPO won't find an appropriate membership since the lesson type is 'reschedule', but the PO doesn't give access to reschedules
            // totally fucked myself on this
            // Need to completely rethink how this function works. Too much complexity, impossible to debug.
            if (
                this.bookingSource.isSelfServe &&
                !this.form.credit &&
                !lesson.type.dropIn
            ) {
                return;
            }

            // in calendarBooking, lesson is fabricated, just has booking info ( such as lesson type or (bool)reschedule )
            // in direct resecheduling or select_credit/client rescheduling, lesson has all lesson data
            let lessonOption =
                lesson?.attendance?.purchase_option || lesson?.purchaseOption;

            if (
                lessonOption?.active &&
                (!lessonOption.ends_at ||
                    moment(lessonOption.ends_at).isAfter(
                        moment(lesson.starts_at)
                    ))
            ) {
                return lessonOption;
            }

            const purchaseOptions =
                this.$_data_filterPurchaseOptions(
                    lesson,
                    student,
                    assessmentType
                ) ?? [];

            let selectOption =
                purchaseOptions?.length == 1 ||
                lesson.type?.assessment ||
                this.bookingSource.isSelfServe ||
                this.bookingSource.isMySchedule
                    ? purchaseOptions[0]
                    : null;

            // match option if possible
            if (lesson.type?.reschedule) {
                let hasCancelledLessons = purchaseOptions?.filter((option) => {
                    return this.apiCancelledLessons?.lessons?.filter(
                        (lesson) => {
                            return lesson.purchaseOption.id == option.id;
                        }
                    ).length;
                });

                if (hasCancelledLessons?.length == 1) {
                    return hasCancelledLessons[0];
                }
            }

            let createAssessmentPO =
                lesson.type.assessment && !selectOption
                    ? //&& this.$page.props.staffView
                      { name: "Due at Checkout", duration: 30 }
                    : null;

            if (
                !purchaseOptions.length &&
                !createAssessmentPO /*&&
                credits <= 1*/
            ) {
                return this.showNoPurchaseOptionAlert();
            }

            return createAssessmentPO ?? selectOption;
        },
        /**
         * @see $_data_studentPurchaseOptions()
         * @see apiCancelledLessons
         * @param {event} lesson should be cancelled and have minutes or pass available
         * @param {event} student
         * @param {event} assessmentType
         * @returns {?object} purchaseOption
         */
        $_data_filterPurchaseOptions(lesson, student, assessmentType) {
            if (!lesson) return console.log("PO filter missing lesson");
            if (!student) return;

            // Set lessonType from group event title or credit, if any`
            let lessonTypeName = lesson.type?.originalType;
            if (lesson.group_event) lessonTypeName = lesson.group_event?.title;
            if (assessmentType?.apl) lessonTypeName = assessmentType.name;

            //console.log(lessonTypeName);

            return this.$_data_studentPurchaseOptions(student).filter(
                (option) => {
                    if (!option.active) return;

                    // check if booking past membership end
                    let bookingPastMembershipEnd = option.ends_at
                        ? moment(option.ends_at).isBefore(
                              moment(lesson.starts_at)
                          )
                        : false;

                    if (bookingPastMembershipEnd) {
                        this.showBookingPastMembershipEndAlert();
                        return;
                    }

                    // match minimum criteria
                    let basePass =
                        option?.access?.includes(lessonTypeName) ||
                        lesson?.group_event?.can_exchange_passes ||
                        // hard coding for now, but should probably be a can_reschedule property on SubRec table
                        option.program == "Accelerated Labs"; /*||
                        str_contains(option.access, "First Visit");*/
                    // While rescheduling
                    if (lesson.type.reschedule) {
                        // if lesson has id, directly rescheduling, get PO type from lesson
                        // duration of this won't be relevant

                        /**
                         * this previously checked if basePass existed and otherwise continued
                         * but was skipping the possibility that a direct reschedule might just not have a valid option
                         * changed as of v1.7511
                         */
                        if (lesson.id) return basePass;

                        /**
                         * @see UpdateRescheduleValues.php
                         * Otherwise grab first cancelled lesson from api
                         * and options that match its type
                         * duration will be deducted from remaining eligible cancelled lessons
                         */

                        return (
                            this.$_data_getAutoCancelledLesson(option) ??
                            basePass
                        );
                    }

                    // at this point, any booking type will require passes > 0
                    if (this.form.duration) {
                        if (this.form.duration != option.duration) return;
                    }
                    // Recurring lessons/events can't be scheduled cross-location
                    // this should probably be a property on subRec
                    if (!lesson.type.recurring) {
                        return basePass && option.passes;
                    }
                    return (
                        basePass &&
                        option.location.id ==
                            this.$page.props.auth.user.selected_location.id &&
                        option.passes
                    );
                }
            );
        },
        /**
         * Determine options by student
         * Mostly exists because mySchedule doesn't load options for each lesson
         * Do this or make api call on user interaction to maintain performance of mySchedule
         * @param {object} student
         * @returns {array} purchaseOptions
         */
        $_data_studentPurchaseOptions(student) {
            if (!student) return console.log("no student found");

            let options =
                student.purchase_options ??
                this.$page.props.sharedSubscriptions?.filter(
                    (e) => e.recipient.id == student.id
                ) ??
                [];

            return options;
        },
        /**
         * Matches passed-in option to canceled lesson option
         * currently returning true if first option is true, but that's not desired
         * what I want is to find if the option passed in has a reschedule available
         * I might need a function ahead of this to handle directly clicking on reschdule credits
         * @param {object} option
         * @returns {object} option
         */
        $_data_getAutoCancelledLesson(option) {
            if (!option) return;

            const matchedOptionLessons =
                this.apiCancelledLessons?.lessons?.find((cancelledLesson) => {
                    if (option.access.includes("Drop-In")) {
                        return cancelledLesson.purchaseOption?.id == option.id;
                    }

                    // If found canceled lesson option can exchange passes (APL)
                    // Then check if the current option has access to the group event
                    // Allows Accelerated Labs to exchange passes for private lessons
                    // This will not allow a passed in APL membership to be used for private lessons!
                    if (cancelledLesson.group_event?.can_exchange_passes) {
                        return option.access.includes(
                            cancelledLesson.group_event.title
                        );
                    }

                    // this is only to find valid rechedules for the purchase option
                    // if you have an active membership, all reschedules are valid!
                    let firstOption = option.access.includes(
                        cancelledLesson.type.originalType
                    );

                    if (firstOption) return firstOption;

                    let lessonOption = cancelledLesson.purchaseOption;

                    return lessonOption?.active &&
                        lessonOption?.cycle &&
                        !lessonOption?.is_event
                        ? true
                        : null;
                });

            // If no cancelled lesson option matches, we should check for APL.
            // Ideally, this would check option.group_event.can_exchange_passes, but that data isn't available here for efficiency
            // SOLUTION: move can_exchange_passes directly to purchase_option? this works for now since it's the only one
            // This actually matches logic I've used elsewhere -> $_data_studentPurchaseOptions, which actually calls this function
            const optionIsAnActiveLabMembership =
                option.active &&
                option.cycle &&
                (!option.is_event || option.program == "Accelerated Labs");

            if (!matchedOptionLessons && optionIsAnActiveLabMembership) {
                // return first lesson;
                if (!this.apiCancelledLessons?.lessons?.length) return null;
                return this.apiCancelledLessons.lessons[0] ?? null;
            }

            return matchedOptionLessons;
        },
    },
    computed: {
        $_data_authIsOnlyTeacher() {
            if (!this.$page.props.staffView) return false;
            if (!this.is("Teacher")) return false;
            if (!this.can("Manage location schedule")) return true;
            return false;
        },
        /*$_data_checkMembershipEnd() {
            if (!this.$_data_getPurchaseOption?.length) return null;
            return this.$_data_getPurchaseOption[0].ends_at;
        },*/
        $_data_lessonStart() {
            if (!this.form.startDate || !this.form.startTime) return null;
            return moment(
                new Date(this.form.startDate + " " + this.form.startTime)
            );
        },
        $_data_lessonEnd() {
            if (!this.$_data_lessonStart || !this.form.duration) return null;
            return moment(this.$_data_lessonStart).add(
                this.form.duration,
                "minutes"
            );
        },
        $_data_bookingGroupEvent() {
            if (this.form.substitutePass) return false;
            return (
                this.event?.group_event ||
                this.form.credit?.group_event ||
                this.form.templateEvent
            );
        },
        $_data_bookingSomethingNew() {
            return (
                (this.form.somethingNew || this.form.somethingNew == null) &&
                this.bookingSource.isMySchedule
            );
        },
        $_data_requiresAssessmentType() {
            if (this.form.assessmentType) return false;
            if (this.form.type?.assessment) return true;
            return this.$_data_teachesPiano || this.bookingSource.isNew;
        },
        $_data_teachesPiano() {
            let teacher = this.form.teacher || this.event?.assignment?.teacher;
            if (!teacher) return null;
            return teacher.instruments.map((e) => e.name).includes("Piano");
        },
    },
};
